import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, useAmendmentSearchDispatch, useAmendmentSearchState } from './amendment-search-context';
import ParlamentarianAppService from '../../../../application/platform/sge/parlamentarian/parlamentarian-app-service';
import PoliticalPartyAppService from '../../../../application/platform/sge/political-party/political-party-app-service';
import BudgetUnitAppService from '../../../../application/platform/sge/budget-unit/budget-unit-app-service';
import BudgetProgramAppService from '../../../../application/platform/sge/budget-program/budget-program-app-service';
import BudgetActionAppService from '../../../../application/platform/sge/budget-action/budget-action-app-service';

const INTEGER_FIELDS: Record<string, string> = {
    'input-year': 'year',
    'select-status': 'status',
    'select-type': 'type',
    'select-parlamentar': 'parlamentarId',
    'select-political-party': 'politicalPartyId',
    'select-budget-action': 'budgetActionId',
};

export const useAmendmentSearchController = () => {
    const navigate = useNavigate();
    const dispatch = useAmendmentSearchDispatch();
    const state = useAmendmentSearchState();

    useEffect(() => {
        ParlamentarianAppService.list({ page: 0, pageSize: 100 }).then((r) =>
            dispatch({ type: ACTION_TYPES.setParlamentarians, payload: r.items })
        );
        PoliticalPartyAppService.list({ page: 0, pageSize: 100 }).then((r) =>
            dispatch({ type: ACTION_TYPES.setPoliticalParties, payload: r.items })
        );
        BudgetUnitAppService.list().then((data) =>
            dispatch({ type: ACTION_TYPES.setBudgetUnits, payload: data })
        );
    }, []);

    useEffect(() => {
        if (state.parameters.budgetUnitId) {
            BudgetProgramAppService.list({ budgetUnitId: state.parameters.budgetUnitId }).then((data) =>
                dispatch({ type: ACTION_TYPES.setBudgetPrograms, payload: data })
            );
        } else {
            dispatch({ type: ACTION_TYPES.setBudgetPrograms, payload: [] });
        }
    }, [state.parameters.budgetUnitId]);

    useEffect(() => {
        if (state.parameters.budgetProgramId) {
            BudgetActionAppService.list({ budgetProgramId: state.parameters.budgetProgramId }).then((data) =>
                dispatch({ type: ACTION_TYPES.setBudgetActions, payload: data })
            );
        } else {
            dispatch({ type: ACTION_TYPES.setBudgetActions, payload: [] });
        }
    }, [state.parameters.budgetProgramId]);

    function handleOnChange(e: any) {
        const { name, value } = e.target;
        if (name === 'select-budget-unit') {
            const parsed = value ? parseInt(value, 10) : undefined;
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { budgetUnitId: parsed, budgetProgramId: undefined, budgetActionId: undefined } });
        } else if (name === 'select-budget-program') {
            const parsed = value ? parseInt(value, 10) : undefined;
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { budgetProgramId: parsed, budgetActionId: undefined } });
        } else if (name in INTEGER_FIELDS) {
            const parsed = parseInt(value, 10);
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { [INTEGER_FIELDS[name]]: isNaN(parsed) ? undefined : parsed } });
        } else if (name === 'input-search') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { search: value || undefined } });
        } else if (name === 'input-min-value') {
            const parsed = parseFloat(value);
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { minValue: isNaN(parsed) ? undefined : parsed } });
        } else if (name === 'input-max-value') {
            const parsed = parseFloat(value);
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { maxValue: isNaN(parsed) ? undefined : parsed } });
        } else if (name === 'input-start-date') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { startDate: value || undefined } });
        } else if (name === 'input-end-date') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { endDate: value || undefined } });
        }
    }

    function handleSearch() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { page: 0 } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                page: 0, pageSize: 100, year: undefined, status: undefined, type: undefined, search: undefined,
                parlamentarId: undefined, politicalPartyId: undefined,
                budgetUnitId: undefined, budgetProgramId: undefined, budgetActionId: undefined,
                minValue: undefined, maxValue: undefined, startDate: undefined, endDate: undefined,
            }
        });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function navigateToCreate() { navigate('/emendas/cadastrar'); }
    function navigateToDetail(id: number) { navigate(`/emendas/${id}`); }
    function navigateToEdit(id: number) { navigate(`/emendas/editar/${id}`); }

    return { handleOnChange, handleSearch, handleClearFilters, navigateToCreate, navigateToDetail, navigateToEdit };
};
